
namespace GeniuzPOS.AdvPromo {
    import row = PsAdvPromoItem5Row.Fields;
    // import di = PsAdvPromoItem5Form.formKey;
    @Serenity.Decorators.registerClass()
    // export class PsAdvPromoItem5ExemptDialog extends  Serenity.EntityDialog<PsAdvPromoItem5ExemptRow, any> {
    //ใช้ Serenity.Extensions.GridEditorDialog ไม่ได้เพราะ จะ กดปุ่มไม่ติด กรณีปุ้มสร้างอยู่ในitemform**
    export class PsAdvPromoItem5ExemptDialog extends Serenity.Extensions.GridEditorDialog<PsAdvPromoItem5ExemptRow> {
        protected getFormKey() { return PsAdvPromoItem5ExemptForm.formKey; }
        // protected getIdProperty() { return PsAdvPromoItem5ExemptRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoItem5ExemptRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoItem5ExemptRow.nameProperty; }
        protected getService() { return PsAdvPromoItem5ExemptService.baseUrl; }
        // protected getDeletePermission() { return PsAdvPromoItem5ExemptRow.deletePermission; }
        // protected getInsertPermission() { return PsAdvPromoItem5ExemptRow.insertPermission; }
        // protected getUpdatePermission() { return PsAdvPromoItem5ExemptRow.updatePermission; }

        protected form = new PsAdvPromoItem5ExemptForm(this.idPrefix);
        private _PmId: string
        private _pmGroupId: string
        private _PmExtCode: string
        private _PmDesc: string
        private _ItemType: string
        private _list: FileList

        public get PmId(): string { return this._PmId }
        set PmId(value: string) {
            this._PmId = value;
            this.form.PmId.value = this._PmId
        }
        public get PmGroupId(): string { return this._pmGroupId }
        set PmGroupId(value: string) { this._pmGroupId = value }
        public get PmExtCode(): string { return this._PmExtCode }
        set PmExtCode(value: string) { this._PmExtCode = value }
        public get PmDesc(): string { return this._PmDesc }
        set PmDesc(value: string) { this._PmDesc = value }
        public get ItemType(): string { return this._ItemType }
        set ItemType(value: string) { this._ItemType = value }


        constructor() {
            super();

            this.form = new PsAdvPromoItem5ExemptForm(this.idPrefix);

            this.form.PluCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.PluCode.value)
                if (Fg != null) {
                    this.form.ListFg.value = 1
                    this.form.StyleCode.value = null
                    this.form.CatCode.value = null
                    this.form.SubCat1Code.value = null
                    this.form.SubCat2Code.value = null
                    this.form.BrandCode.value = null
                    this.form.SupplCode.value = null
                }
                if (Fg = null) {
                    this.form.ListFg.value = 2
                }
            });
            this.form.StyleCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.StyleCode.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.CatCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.CatCode.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat1Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat1Code.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SubCat2Code.changeSelect2(e => {
                let Fg = Q.toId(this.form.SubCat2Code.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.SupplCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.SupplCode.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });
            this.form.BrandCode.changeSelect2(e => {
                let Fg = Q.toId(this.form.BrandCode.value)
                if (Fg != null) {
                    this.form.ListFg.value = 2
                    this.form.PluCode.value = null
                }
                
            });

            this.form.PmExtCode.changeSelect2(e => {
                let ex = Q.toId(this.form.PmExtCode.value)
                let gp = Q.toId(this.form.PmGroupId.value)
                this.form.PmId.value = ex + gp;
            });


            
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);


            let newBtn: Serenity.ToolButton =
            {
                title: "เพิ่ม",
                hint: "Save and new[alt+s]",
                separator: false,
                cssClass: "button-save",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: () => {
                    // e.preventDefault();
                    // const vp = Serenity.Extensions.GridEditorDialog<PsAdvPromoItem5ExemptRow>
                    // const dia = this extend vp;
                    // vp.onSave = (opt, callback) => this.save(opt, callback);
                    // this.form.PmExtCode.value = this._PmExtCode;
                    // this.form.PmId.value = this._PmId;
                    // this.form.PmDesc.value = this._PmDesc;
                    // this.form.ItemType.value = this._ItemType;
                    // this.form.PmGroupId.value = this._pmGroupId
                    // Serenity.SubDialogHelper.triggerDataChange(this);
                    if (!Q.isEmptyOrNull(this.form.PluCode.value)) {
                        this.form.ListFg.value = 1
                        this.form.StyleCode.value = null
                        this.form.CatCode.value = null
                        this.form.SubCat1Code.value = null
                        this.form.SubCat2Code.value = null
                        this.form.BrandCode.value = null
                        this.form.SupplCode.value = null
                    }

                    this.save((response) => {

                        this.dialogClose();
                    });
                }
            };
            buttons.push(newBtn);
            if (this.isNew) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบ'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "deletee-button",
                    icon: "fa fa-trash",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        // Q.confirm('ยืนยันการลบ', () => {
                            this.doDelete(() => {
                                this.dialogClose();
                            });
                        // });
                    }
                };
                buttons.push(newDeleteBtn);
            }

            // buttons.push(
            //     {
            //         title: Q.text("Close"),	// *** Get button text from translation
            //         cssClass: '.panel-titlebar-close',
            //         icon: 'fa-close',
            //         onClick: () => {
            //             this.dialogClose();
            //             // *** do something on click if you want **

            //         },
            //     }
            // );

            return buttons;
        }
       

        protected afterLoadEntity() {
            super.afterLoadEntity();
            // let request =  Serenity.Extensions.GridEditorDialog<PsAdvPromoItem5Row>;
            // let w = getCloningEntity()
            console.log(this._pmGroupId)
            // this.form.PmId.value = this._PmId;
            // // this.form.PmGroupId.value = this._pmGroupId;
            // this.form.PmExtCode.value = this._PmExtCode;
            // this.form.PmDesc.value = this._PmDesc;
            // this.form.ItemType.value = this._ItemType;
            // Serenity.EditorUtils.setReadOnly(this.form.PmExtCode, true);
            // Serenity.EditorUtils.setReadOnly(this.form.PmDesc, true);
            // Serenity.EditorUtils.setReadOnly(this.form.ItemType, true);
            
        }




    }

}